export const click = ()=>({type: 'click'})
export const addQuestion = (question)=>({type: 'add_question', question})
export const changeQuestionField = (index, field, value)=>({type: 'change_question_value', index, field, value})
export const removeQuestion = (index)=>({ type: 'remove_question', index })
export const addAnswer = (index, answer)=>({ type: 'add_answer', index, answer })
export const updateAnswer = (questionIndex, index, answer)=>({ type: 'update_answer', questionIndex, index, answer })
export const updateAllAnswers = (questionIndex, index, answer)=>({ type: 'update_all_answers', questionIndex, answer })
export const removeAnswer = (questionIndex, index)=>({ type: 'remove_answer', questionIndex, index })
